import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MJSJobComponent } from './mjs-job.component';

const routes: Routes = [{
  path: '',
  component: MJSJobComponent,
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MJSJobRoutingModule { }
